<template>
  <div
    style="
      font-family: -apple-system-font,  Helvetica Neue, Helvetica,
        STHeiTi, sans-serif;
    "
  >
    <!--    <div class="carousel" :style="{ backgroundImage: `url(${detail.productBackground})`, backgroundSize: '100% 100%' }">-->
    <!--      案例精选-->
    <!--    </div>-->

    <BannerImg
      bannerPosition="STHB_BANNER"
      :title="detail.caseTitle"
      :subTitle="detail.caseContent"
      :showZiXun="true"
      class="top"
    />

    <div class="solution-container flex flex-col">
      <div class="solution-head m-auto" :class="{'fixed': isNavFixed}">
        <el-row class="w-full flex justify-center">
          <el-col
            :xs="8"
            :md="3"
            :lg="2"
            v-for="(item, index) in detail.contentList"
            :key="item.id"
            v-if="item.title"
            style="cursor: pointer"
          >
            <span
              class="solution-head-title text-base font-medium"
              :class="{ active: active == index }"
              @click="handlePositionClock(index)"
              >{{ item.title.replace(/[【】]/g, "") }}</span
            >
          </el-col>
        </el-row>
      </div>

      <div
        class="solution-contant flex flex-col justify-center items-center m-auto gap-5"
      >
        <div
          v-for="(item, index) in detail.contentList"
          :key="item.id"
          class="flex"
        >
          <div v-if="item.id === '相关方案'" id="相关方案" :id="'id' + index">
            <el-row :gutter="20" class="xxxxxx">
              <div
                class="solution-contant-title text-3xl font-semibold leading-[normal] grid grid-cols-1 gap-4 place-content-center w-full"
              >
                相关方案
              </div>
              <el-col class="dxal-box" :xs="24" :sm="8" :lg="6">
                <div
                  v-for="item2 in sList"
                  :key="item2.id"
                  class="box"
                  @click="toPage(item2)"
                >
                  <div style="width: 100%; height: 100%">
                    <img style="width: 100%" :src="item2.schemeCover" alt="" />
                  </div>
                  <div class="dxal-title">{{ item2.solutionTitle }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-else :id="'id' + index">
            <div
              class="solution-contant-title text-3xl font-semibold leading-[normal] grid grid-cols-1 gap-4 place-content-center w-full"
              v-if="item.title"
            >
              {{ item.title }}
            </div>
            <section></section>
            <div
              style="
                line-height: 28px;
                margin-bottom: 60px;
                font-size: 18px;
                color: #000;
                font-weight: 500;
              "
              class="section flex flex-col justify-center items-center"
              v-if="item.type === 'introduction' && item.introduction"
            >
              {{ item.introduction }}
            </div>
            <div
              class="section flex flex-col justify-center items-center"
              v-if="item.type === 'video' && item.video"
            >
              <video style="width: 996px" muted loop controls>
                <source type="video/mp4" :src="item.video" />
              </video>
            </div>
            <div
              class="section flex flex-col justify-center items-center"
              v-if="item.type === 'picture' && item.picture"
            >
              <img style="width: 996px" :src="item.picture" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showButton" class="to-top" @click="totop()">
      <img src="../assets/images/totop.png" alt="" />
    </div>
  </div>
</template>

<script>
import { detailCase, detailSolution } from "@/api";
import BannerImg from "@/components/BannerImg.vue";
import EiiCard from "@/components/EiiCard.vue";

export default {
  name: "CaseZjnxhjjDetail",
  components: { EiiCard, BannerImg },
  data() {
    return {
          // 返回顶部按钮
          showButton: false,
      isNavFixed: false,  
      detail: {},
      active: 0,
      sList: [],
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    window.addEventListener('scroll',  this.handleScroll);  
    }, 
  beforeDestroy() {
    window.removeEventListener('scroll',  this.handleScroll);  
  },
  methods: {
    totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
    handleScroll() {  
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;  
      const topHeight = this.$el.querySelector('.top').offsetHeight;  
      this.isNavFixed = scrollTop >= topHeight;  
      this.showButton  = window.scrollY  > 200; 
      console.log(scrollTop, "获取当前滚动的距离距离顶部多少像素");  
    },  
    toPage(item) {
      this.$router.push({ name: "SolutionDetails", query: { id: item.id } });
    },
    handlePositionClock(index) {
      this.active = index;
      this.$el.querySelector(`#id${index}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "center",
      });
    },
    async getData() {
      const res = await detailCase({ id: this.$route.query.id });
      this.detail = res.data;
      if (this.detail.contentList && this.detail.contentList[0].linkInfo) {
        const ids = this.detail.contentList[0].linkInfo.split(",");
        ids.forEach((item) => {
          detailSolution({ id: item }).then((res2) => {
            this.sList.push(res2.data);
          });
        });

        this.detail.contentList.push({
          id: "相关方案",
          title: "相关方案",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
.fixed {  
  z-index: 999999;
  position: fixed;
    top: 60px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff !important;
}  
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;
  min-height: 440px;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;

      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;

    img {
      width: 100%;
    }

    .model {
      margin-top: 0.2rem;

      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }

      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}

.solution-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1280px;
  margin: 0 auto;

  .solution-head {
    width: 100%;
    text-align: center;
    padding-top: 10px;

    .solution-head-title {
      display: inline-flex;
      height: 60px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
    }

    .active {
      color: var(--color-primary, #e10009);
      border-bottom: 2px solid var(--color-primary, #d7000f);
    }
  }

  .solution-contant {
    max-width: 1440px;

    .solution-contant-title {
      margin: 60px auto 60px;
      text-align: center;
      color: #000000;
    }
    .dxal-box {
      cursor: pointer;
      padding-left: 10px;
      padding-right: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
      .box {
        margin-right: 15px;
        > div {
          width: 100%;
        }
        .dxal-title {
          position: relative;
          top: -90px;
          background: #0006;
          color: #fff;
          text-align: center;
          height: 45px;
          line-height: 45px;
          font-size: 14px;
        }
      }
    }
    margin-bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CaseDetailCommon.vue